// Show/hide variant descriptions based on selected option (supports both pill and swatch styles)
(function() {
  function updateDescription(input) {
    const fieldset = input.closest('.product-form__input--pill, .product-form__input--swatch');
    if (!fieldset) return;

    // Hide all descriptions in this fieldset
    const allDescriptions = fieldset.querySelectorAll('.variant-description-text');
    allDescriptions.forEach(desc => desc.style.display = 'none');

    // Show the description matching the selected value
    const selectedValue = input.value;
    const matchingDescription = fieldset.querySelector(`.variant-description-text[data-variant-value="${selectedValue}"]`);

    if (matchingDescription) {
      matchingDescription.style.display = 'block';
    }
  }

  function initDescriptions() {
    const pillInputs = document.querySelectorAll('.product-form__input--pill input[type="radio"], .product-form__input--swatch input[type="radio"]');

    // Update on load for already-selected options
    pillInputs.forEach(input => {
      if (input.checked) {
        updateDescription(input);
      }

      // Remove old listeners and add new ones to avoid duplicates
      input.removeEventListener('change', handleChange);
      input.addEventListener('change', handleChange);
    });
  }

  function handleChange(event) {
    updateDescription(event.target);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptions);
  } else {
    initDescriptions();
  }

  // Re-initialize after variant changes (for Shopify's dynamic updates)
  if (typeof Shopify !== 'undefined' && Shopify.theme) {
    document.addEventListener('shopify:section:load', initDescriptions);
  }

  // Re-initialize when variants are updated via AJAX (variant picker HTML replacement)
  // Use MutationObserver to detect when variant-selects content changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if any added nodes contain or are pill/swatch inputs
        const hasVariantInputs = Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType === 1) { // Element node
            return node.matches?.('.product-form__input--pill, .product-form__input--swatch') ||
                   node.querySelector?.('.product-form__input--pill, .product-form__input--swatch');
          }
          return false;
        });

        if (hasVariantInputs) {
          // Small delay to ensure DOM is fully updated
          setTimeout(initDescriptions, 50);
        }
      }
    });
  });

  // Observe the entire product-info element for changes
  const productInfo = document.querySelector('product-info');
  if (productInfo) {
    observer.observe(productInfo, {
      childList: true,
      subtree: true
    });
  }
})();
